export { default as BOTLocation } from 'components/HyperLocalPages/DirectoryPage/BOTLocation'
